import { useEffect, useState, useRef } from "react";
import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || 'https://bobine.live');
const API = `${BACKEND_URL}/api`;
const STORAGE_KEY = 'bobine_fondatrice_view_counted';

/* ── Compteur "Ils ont écouté l'histoire de Bobine" ──
   - Lit la valeur côté serveur au mount.
   - Incrémente une seule fois par appareil (localStorage flag).
   - Italique Or (#D4AF37) strict, charte Bobine.
   - Détecte automatiquement la <video> de la fondatrice via querySelector.
*/
const FondatriceViewCounter = () => {
  const [count, setCount] = useState(null);
  const incrementedRef = useRef(false);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/fondatrice/views`)
      .then(r => { if (!cancelled && r.data?.count != null) setCount(r.data.count); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    let video = null;
    let attached = false;

    const handler = async () => {
      if (incrementedRef.current) return;
      incrementedRef.current = true;
      if (localStorage.getItem(STORAGE_KEY) === '1') return;
      try {
        const r = await axios.post(`${API}/fondatrice/view`);
        if (r.data?.count != null) setCount(r.data.count);
        localStorage.setItem(STORAGE_KEY, '1');
      } catch (e) { /* silent */ }
    };

    const tryAttach = () => {
      if (attached) return;
      const candidates = Array.from(document.querySelectorAll('video'));
      const found = candidates.find(v => (v.currentSrc || v.src || '').includes('/fondatrice/video'));
      if (found) {
        video = found;
        video.addEventListener('play', handler);
        attached = true;
      }
    };

    tryAttach();
    const interval = setInterval(tryAttach, 800);
    setTimeout(() => clearInterval(interval), 8000);

    return () => {
      clearInterval(interval);
      if (video && attached) video.removeEventListener('play', handler);
    };
  }, []);

  if (count == null) return null;

  const label = count > 1
    ? `${count.toLocaleString('fr-FR')} personnes ont écouté l'histoire de Bobine`
    : `${count} personne a écouté l'histoire de Bobine`;

  return (
    <p
      data-testid="fondatrice-view-counter"
      style={{
        fontFamily: "'Georgia', serif",
        fontSize: 12,
        color: '#D4AF37',
        fontStyle: 'italic',
        letterSpacing: 0.4,
        margin: '14px 0 0',
        textAlign: 'center',
        opacity: 0.85,
      }}
    >
      ✦ {label}
    </p>
  );
};

export default FondatriceViewCounter;
